/**
 * Refresh and open the shopping cart
 */
window.openShoppingCart = (): void => {
    window.toggleOverlay("cart", "side-menu");

    // @ts-ignore
    jax.request(null, "onOpenCart", {
        flash: true,
        update: {
            "Cart::default": "#page-side-menu",
        },
    });
};